
import { Skeleton } from "@/components/ui/skeleton";

export function CourseLoading() {
  return (
    <div className="p-8 space-y-8">
      {/* Course details skeleton */}
      <div className="border rounded-lg p-6">
        <div className="flex justify-between items-center mb-6">
          <Skeleton className="h-8 w-64" />
          <Skeleton className="h-9 w-20" />
        </div>
        <div className="grid gap-6 md:grid-cols-2">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="space-y-2">
              <Skeleton className="h-4 w-24" />
              <Skeleton className="h-8 w-full" />
            </div>
          ))}
        </div>
        <div className="mt-6 space-y-2">
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-32 w-full" />
        </div>
      </div>
      
      {/* Course modules skeleton */}
      <div className="border rounded-lg p-6">
        <div className="flex justify-between items-center mb-6">
          <Skeleton className="h-8 w-48" />
          <Skeleton className="h-9 w-20" />
        </div>
        {[...Array(3)].map((_, i) => (
          <div key={i} className="py-4 border-b last:border-0">
            <div className="flex justify-between items-center mb-2">
              <Skeleton className="h-6 w-60" />
              <Skeleton className="h-8 w-24" />
            </div>
            <Skeleton className="h-4 w-1/3" />
          </div>
        ))}
      </div>
    </div>
  );
}
